'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.localStore = localStore;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function localStore(lcName) {
  var localName = lcName || 'Lookme';
  if (global.localStorage) {
    if (!localStorage[localName]) {
      localStorage[localName] = '{}';
    }
    var __localStorage = JSON.parse(localStorage[localName]),
        __readLocal = function __readLocal(key) {
      return __localStorage[key];
    },
        __writeLocal = function __writeLocal(key, val) {
      __localStorage[key] = val;
      localStorage[localName] = (0, _stringify2.default)(__localStorage);
    },
        __clearLocal = function __clearLocal(key) {
      delete __localStorage[key];
      localStorage[localName] = (0, _stringify2.default)(__localStorage);
      return __localStorage[key];
    };
    return {
      get: __readLocal,
      set: __writeLocal,
      clear: __clearLocal
    };
  }
  return {
    get: function get() {},
    set: function set() {},
    clear: function clear() {}
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/localStorage.js
// module id = 59
// module chunks = 0